import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Logo from '../../assets/images/logo/hp.png';
import { Card } from '@veneer/core';

class PublicLayout extends Component {
  render() {
    const { children } = this.props;
    return (
      <Container>
        <div style={{marginTop: '100px', marginBottom: '20px'}}>
          <span>
            <img style={{display: 'block', margin: 'auto'}} src={Logo} alt="HP Logo" height="80"></img>
          </span>
        </div>
        <Card content={children} appearance="dropShadow" className="public-layout-card" />
      </Container>
    );
  }
}

export default PublicLayout;
